export const GOOGLE_MAPS_ENABLED = 'WEB-google-maps-sales-flow';
export const SANITY_SUBSIDY_NAME = 'WEB-sanity-subsidy';
export const NEWSLETTER_CONSENT_FEATURE_NAME = 'WEB-newsletter-consent';
export const LEASING_SUBSIDY_HIDDEN = 'WEB-leasing-subsidy-hidden';
export const ENABLE_CLOUD_DEBUG_TOOL_NAME = 'WEB-enable-cloud-debug-tool';
export const GLOBAL_ALERT = 'WEB-global-alert';
export const OPEN_DROPDOWN_IN_SAVINGS_INITIALLY =
  'WEB-open-dropdown-savings-initially-calc-page';
export const FREE_TEXT_ADDRESS_SEARCH_ENABLED =
  'free-text-address-search-enabled';
export const SHOW_OR_SIMILAR_FOR_PANELS = 'show-or-similar-for-panels';
export const SHOW_OR_SIMILAR_FOR_INVERTERS = 'show-or-similar-for-inverters';
export const SHOW_OR_SIMILAR_FOR_BATTERIES = 'show-or-similar-for-batteries';
export const SHOW_OR_SIMILAR_FOR_SMART_METERS =
  'show-or-similar-for-smart-meters';
export const SHOW_REPAYMENT_PLAN_START_BALANCE =
  'WEB-show-repayment-plan-start-balance';
export const SHOW_REPRESENTATIVE_EXAMPLES_ON_CALC_PAGE =
  'WEB-show-representative-examples-on-calc-page';
export const SHOW_APR_AND_CASH_PRICE_LEASING_HEADER =
  'WEB-show-apr-and-cash-price-leasing-header';
export const SHOW_INFO_SECTION_ON_CALC_PAGE =
  'WEB-show-info-section-on-calc-page';
export const SHOW_SOCIAL_PROOF_SECTION_CALC_PAGE =
  'WEB-show-social-proof-section-on-calc-page';
export const POSTHOG_ENABLED = 'WEB-posthog-enabled';
export const SHOW_STANDALONE_BATTERY_PACKAGE_SUMMARY_V2 =
  'WEB-show-standalone-battery-package-summary-v2';
export const OTOVO_CARE_ACTIVE = 'otovo-care-active';
export const OTOVO_CARE_COMING_SOON = 'otovo-care-coming-soon';
export const POLISH_FINANCIAL_LEASING = 'polish-financial-leasing';
